import "./heading.css";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import FiltersDashboard from "../filters/filtersDashboard";
import { BaseHeading } from "../../../types/baseHeading";

export interface HeadingDashboardOne extends BaseHeading {
  materialData?: {
    sessionId: string;
    productCode: string;
    productSimilarCode?: string | null;
    classificationStatus: string;
    classificationID: string;
  };
}

export const HeadingDashboard = ({
  titlePage,
  filtros,
  emitentePartNumber,
  setEmitentePartDesc,
  setStartDate,
  startDate,
  endDate,
  setEndDate,
  handleFilter,
  setPage,
}: HeadingDashboardOne) => {
  const [, setIsSimilar] = useState(false);

  const { sessionVerify } = useSelector(
    (state: RootState) => state.sessionInfo
  );

  useEffect(() => {
    if (sessionVerify) {
      setIsSimilar(sessionVerify?.isSimilar);
    }
  }, [sessionVerify]);

  return (
    <div className="containerHeading">
      <div className="upperHome">
        <div>
          <span className="titleHome">{titlePage}</span>
        </div>
      </div>

      {filtros && (
        <div>
          <div style={{ height: "35px", marginTop: "10px" }}>
            <span>Filtros</span>
          </div>

          <div>
            <FiltersDashboard
              emitentePartNumber={emitentePartNumber}
              setEmitentePartDesc={setEmitentePartDesc}
              setStartDate={setStartDate}
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleFilter={handleFilter}
              setPage={setPage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HeadingDashboard;
